import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import LargeHero from "./components/content/LargeHero";
import FindUsLive from "./components/content/FindUsLive";
import NewInSection from "./components/content/NewInSection";
import MerchSection from "./components/content/MerchSection";
import AboutSection from "./components/content/AboutSection";
import FounderSection from "./components/content/FounderSection";
import ContactSection from "./components/content/ContactSection";

const Index = () => {
  const [bagCount] = useState(0);
  const [wishCount] = useState(0);

  return (
    <div className="App">
      <Header bagCount={bagCount} wishCount={wishCount} />
      <LargeHero />
      <FindUsLive />
      <NewInSection />
      <MerchSection />
      <AboutSection />
      <FounderSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
